import {
  SET_TRIAL_CATEGORY,
  TrialCategoryActionTypes,
  TrialCategoryState,
} from '../types';

const initialState: TrialCategoryState = {
  categories: [],
};

function TrialCategoriesReducer(
  state: TrialCategoryState = initialState,
  action: TrialCategoryActionTypes,
): TrialCategoryState {
  switch (action.type) {
    case SET_TRIAL_CATEGORY:
      return {
        ...state,
        categories: action.payload,
      };
    default:
      return state;
  }
}

export default TrialCategoriesReducer;
